// src/pages/NotFound.tsx
import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const NotFound: React.FC = () => {
  const { t } = useTranslation('legal');
  const { t: tCommon } = useTranslation('common');

  return (
    <div className="flex flex-col items-center justify-center min-h-[80vh] text-center p-4">
      <h1 className="text-4xl font-bold mb-4">{t('notFound.title')}</h1>
      <p className="text-lg mb-8">{t('notFound.message')}</p>
      <Link
        to="/"
        className="bg-gradient-to-r from-yellow-400 to-orange-500 text-[#0a0a0a] font-semibold py-2 px-6 rounded-lg shadow-lg hover:scale-105 transition"
      >
        {tCommon('actions.goHome')}
      </Link>
    </div>
  );
};

export default NotFound;
